<template>
    <div class="order_detial" v-loading="loading">
        <div class="order_titles">委托详情</div>
        <div class="order_detial_box1">
            <div class="order_type">
                <div class="type_item" v-for="(item, index) in type_list" :key="index" :class="{ tyle_ac: tyle_ac >= index }">
                    <div class="type_icons">
                        <div class="lefts">
                            <div class="borders" v-if="index != 0"></div>
                        </div>
                        <div class="consts">
                            <div class="icons">{{ index + 1 }}</div>
                        </div>
                        <div class="rigths">
                            <div class="borders" v-if="index != (type_list.length - 1)"></div>
                        </div>
                    </div>
                    <div class="type_title">{{ item.title }}</div>
                    <div class="type_time">{{ item.times }}</div>
                </div>
            </div>
            <div class="order_state">
                <div class="lefts">
                    订单号：{{ order_detial.order_sn }}   <span @click="handle_cope">复制</span>
                </div>
                <div class="rights">
                    订单状态：
                    <span v-if="order_detial.status==20">待服务</span>
                    <span v-if="order_detial.status==30">服务中</span>
                    <span v-if="order_detial.status==40">已完成</span>
                    <span v-if="order_detial.status==50">已完成</span>
                </div>
            </div>
        </div>
        <div class="order_detial_box2">
            <div class="title_flex">
                <div class="lefts">
                    <img src="@/assets/img/user_info/user_dp/icon1.png" alt="">
                    我的委托
                </div>
                <div class="rights">
                    <!-- 收起
                    <img src="@/assets/img/user_info/user_dp/icon3.png" alt=""> -->

                </div>
            </div>
            <div class="box_titles">案件类型</div>
            <div class="info_box1">
                <div class="info_flex">
                    <div class="info_text1">案件类型：</div>
                    <div class="info_text2">{{minx_get_case_type(order_detial.case_type)}}</div>
                </div>
                <div class="info_flex" v-if="minx_get_custom_type(order_detial.custom_type)">
                    <div class="info_text1">申请人类型：</div>
                    <div class="info_text2">{{ minx_get_custom_type(order_detial.custom_type)}}</div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">联系人姓名：</div>
                    <div class="info_text2">{{ order_detial.custom_name }}</div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">手机号：</div>
                    <div class="info_text2">{{ order_detial.custom_phone }}</div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">所在地区：</div>
                    <div class="info_text2">
                        {{minx_get_province_cita_area(order_detial.province,order_detial.city,order_detial.area)  }}
                    </div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">电子邮箱：</div>
                    <div class="info_text2">{{ order_detial.email }}</div>
                </div>
            </div>
            <div class="box_titles">当事人信息</div>

            
            <div class="info_box2" v-if="order_detial.proceed==1">
                <div class="dsr_info">
                    <div class="dsr_titles">原告</div>
                    <div class="dsr_border">
                        <div class="border1"></div>
                        <div class="border2"></div>
                    </div>
                    <div class="dsr_box" v-for="(item,index) in plaint_json" :key="index">
                        <div class="dsr_index">
                            {{ index+1 }}
                        </div>
                        <div class="dsr_items">
                            <div class="dsr_name" @click="handle_name(item,1)">{{ item.name }}</div>
                            <div class="dsr_tages" v-if="item.yuangao==1">
                                <div class="tages">性别：{{ item.sex==1?'男':( item.sex==2?'女':'未知') }}</div>
                                <div class="tages">民族：{{ item.native }}</div>
                                <div class="tages">居住地址：{{ item.address1 }}</div>
                            </div>
                            <div class="dsr_tages" v-if="item.yuangao!=1">
                                <div class="tages">机构所在地址：{{ item.address }}</div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div class="dsr_info">
                    <div class="dsr_titles">被告</div>
                    <div class="dsr_border">
                        <div class="border1"></div>
                        <div class="border2"></div>
                    </div>
                    <div class="dsr_box" v-for="(item,index) in defendant_json" :key="index">
                        <div class="dsr_index">
                            {{ index+1 }}
                        </div>
                        <div class="dsr_items">
                            <div class="dsr_name" @click="handle_name(item,1)">{{ item.name }}</div>
                            <div class="dsr_tages" v-if="item.yuangao==1">
                                <div class="tages">性别：{{ item.sex==1?'男':( item.sex==2?'女':'未知') }}</div>
                                <div class="tages">民族：{{ item.native }}</div>
                                <div class="tages">居住地址：{{ item.address1 }}</div>
                            </div>
                        </div>
                        <div class="dsr_items" v-if="item.yuangao!=1">
                          
                          <div class="tages">机构所在地址：{{ item.address }}</div>
                      </div>
                    </div>
                </div>
                <div class="dsr_info">
                    <div class="dsr_titles">第三人</div>
                    <div class="dsr_border">
                        <div class="border1"></div>
                        <div class="border2"></div>
                    </div>
                    <div class="dsr_box" v-for="(item,index) in third_json" :key="index">
                        <div class="dsr_index">
                            {{ index+1 }}
                        </div>
                        <div class="dsr_items">
                            <div class="dsr_name" @click="handle_name(item,1)">{{ item.name }}</div>
                            <div class="dsr_tages" v-if="item.yuangao==1">
                                <div class="tages">性别：{{ item.sex==1?'男':( item.sex==2?'女':'未知') }}</div>
                                <div class="tages">民族：{{ item.native }}</div>
                                <div class="tages">居住地址：{{ item.address1 }}</div>
                            </div>
                        </div>
                        <div class="dsr_items" v-if="item.yuangao!=1">
                          
                          <div class="tages">机构所在地址：{{ item.address }}</div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="box_titles">材料信息</div>

            <div class="info_box3">
                <div class="info_flex">
                    <div class="info_text1">案件描述：</div>
                    <div class="info_text2">{{ order_detial.mater_file }}</div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">诉讼请求：</div>
                    <div class="info_text2">{{ order_detial.content }}</div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">证据材料：</div>
                    <div class="info_text2">
                        <div class="urls" v-for="(item,index) in prove_imgs" :key="index" @click="handle_url(item)">{{ item.name }}</div>
                        <!-- 证据清单及文件附件名称.pdf -->
                        <!-- <br> -->
                        <!-- 证据清单及文件附件名称.pdf -->
                    </div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">其他材料：</div>
                    <div class="info_text2">
                        <div class="urls" v-for="(item,index) in other_imgs" :key="index"  @click="handle_url(item)">{{ item.name }}</div>

                    </div>
                </div>
                <div class="info_flex">
                    <div class="info_text1">其他补充：</div>
                    <div class="info_text2">{{ order_detial.o_content }}</div>
                </div>
                
            </div>
            <div class="title_flex">
                <div class="lefts">
                    <img src="@/assets/img/user_info/user_dp/icon4.png" alt="">
                    承接律师
                </div>
            </div>
            <div class="info_box4">
                <div class="list_0" v-if="wt_list.length==0">
                    <img src="@/assets/img/user_info/user_wt/no_bg.png" alt="">
                    <div class="">暂无承接律师</div>
                </div>
                <div class="wt_list" v-if="wt_list.length!=0">
                    <div class="wt_item" v-for="(item,index) in wt_list" :key="index">
                        <div class="item_tops">
                            <div class="top_lefts">
                                <div class="cjls_img">
                                    <img :src="item.business_img" alt="">
                                </div>
                            </div>
                            <div class="top_rights">
                                <div class="cjls_info">
                                    <div class="cjls_name">{{ item.name }}<img src="../../../../assets/img/index/legal/vips.png" alt=""></div>
                                    <div class="cjls_tage">
                                        {{ item.work_company }}
                                    </div>
                                    <div class="cjls_consts">
                                      {{ item.serve }}
                                    </div>
                                </div>
                                <div class="cjls_btns">
                                    <div class="btns" @click="handle_phone">联系律师</div>
                                </div>
                            </div>
                        </div>
                        <div class="item_boms">
                            <div class="num_flex">
                                <div class="num_item">
                                    案件数量：<span>{{ item.order_num }}</span>
                                </div>
                                <div class="num_item">
                                    好评率：<span>{{  item.good_lv }}</span>
                                </div>
                                <div class="num_item">
                                    评价数：<span>{{ item.comment_num }}</span>
                                </div>
                            </div>
                            <div class="num_btns" @click="handle_ls(item)">律师详情 ></div>
                           
                        </div>
                    </div>
                </div>
            </div>
            <div class="title_flex" v-if="amdinUser.username">
                <div class="lefts">
                    <img src="@/assets/img/user_info/user_dp/icon4.png" alt="">
                    法务监理
                </div>
            </div>
            <div class="info_box5" v-if="amdinUser.username">
                <div class="fwjl_flex">
                    <div class="fwjl_left">
                        <img :src="amdinUser.avatar" alt="">
                    </div>
                    <div class="fwjl_right">
                        <div class="fwjl_name">{{ amdinUser.username }} </div>
                        <div class="fwjl_jianjie">
                            {{ order_detial.jianliContent }}
                        </div>
                        <div class="fwjl_nums">
                            <div class="num_box">
                                <img src="@/assets/img/user_info/user_wt/icon1.png" alt="">
                                固话：<span>{{ amdinUser.tel }}</span>
                            </div>
                            <div class="num_box">
                                <img src="@/assets/img/user_info/user_wt/icon2.png" alt="">
                                手机号：<span>{{ amdinUser.phone }}</span>
                            </div>
                            <div class="num_box">
                                <img src="@/assets/img/user_info/user_wt/icon3.png" alt="">
                                微信：<span>{{ amdinUser.wx }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order_info" v-if="carry_order.id">
                <div class="info_top">
                    <div class="texts">
                        携带订单
                    </div>
                </div>
                <div class="info_bom">
                    <div class="text_flex">
                        <div class="text1">
                            {{  carry_order.order_sn}}
                            <el-button type="text" @click="$router.push('/user_order/order_detial?id='+carry_order.id)">查看订单详情</el-button>
                        </div>
                    </div>
                    
                    <div class="text_flex text_flex2">
                        <div class="text3">
                            <div class="text3_1">案件类型：</div>
                            <div class="text3_2">{{minx_get_case_type(carry_order.case_type)}}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">申请人类型：</div>
                            <div class="text3_2">{{ minx_get_custom_type(carry_order.custom_type)}}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">联系人姓名：</div>
                            <div class="text3_2">{{ carry_order.custom_name }}</div>
                        </div>
                    </div>


                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">手机号：</div>
                            <div class="text3_2">{{ carry_order.custom_phone }}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">所在地区：</div>
                            <div class="text3_2">  {{minx_get_province_cita_area(carry_order.province,carry_order.city,carry_order.area)  }}</div>
                        </div>
                    </div>
                     <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">电子邮箱：</div>
                            <div class="text3_2">{{ order_detial.email }}</div>
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
         <user_wt ref="user_wt"></user_wt>
   
    </div>
</template>
<script>
import { mapState } from 'vuex'
import user_wt from '@/components/user_wt/user_wt.vue'//律所

 

export default {
    components: {
        user_wt,

    },
    name: "homes",
    data() {
        return {
            loading: false,
            tyle_ac: 0,
            type_list: [
                
            ],
            wt_list:[],
            order_detial:[],
            plaint_json:[],//原告
            defendant_json:[],//被告
            third_json:[],//第三人
            amdinUser:{},//监理
            prove_imgs:[],//证明材料（多图）
            other_imgs:[],//其他材料（多img）

            carry_order:{},

       
         
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_detial()
    },
    methods: {
        handle_cope(){
            navigator.clipboard.writeText(this.order_detial.order_sn).then(function() {
                alertSucc("复制成功！");
            }).catch(function(err) {
                alertErr("复制失败：" + err);
            });
        },
        get_detial(){
            this.loading=true
            this.$api("myOrderDetail", {
               
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('我的委托详情',res)
                if (res.code == 1) {
                    this.order_detial=res.data
                    this.plaint_json=res.data.plaint_json
                    this.defendant_json=res.data.defendant_json
                    this.third_json=res.data.third_json
                    this.amdinUser=res.data.amdinUser
                    this.prove_imgs=JSON.parse(res.data.prove_imgs) 
                    this.other_imgs=JSON.parse(res.data.other_imgs) 
                    this.carry_order=res.data.carry_order

                   
                    this.type_list=[
                        {
                            title: '提交订单',
                            times: res.data.created_at
                        },
                        {
                            title: '服务中',
                            times: res.data.receive_time
                        },
                        {
                            title: '已完成',
                            times: res.data.finish_time
                        }
                    ]
                    if(res.data.receive_time){
                        this.tyle_ac=1
                    }
                    if(res.data.status==40||res.data.status==50){
                        this.tyle_ac=2
                    }
                    
                    this.get_wt_list(res.data.lawyer)
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_url(item){
            window.open(item.path)
        },
        get_wt_list(lawyer){
            this.loading = true
            this.$api("lawyers", {
                lawyerId:lawyer.id
			}, "get").then((res) => {
                this.loading = false
                console.log('律师列表',res)
                if (res.code == 1) {
                    this.wt_list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_ls(item){
            this.$router.push({
                path:'/lawyer_detial',
                query:{
                    id:item.id
                }

            })
        },
        handle_name(item,i){
            this.$refs.user_wt.handle_open(item,i)
        },
        handle_phone(){
            console.log('律师',this.order_detial.lawyer)
            window.location.href =  'tel:+'+this.order_detial.lawyer.mobile;
           
        },



    },

}
</script>
<style scoped lang="less">
.order_detial {
    .order_titles {
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }

    .order_detial_box1 {
        margin-top: 24px;
        padding: 72px 24px;
        background: #FFFFFF;
        .order_type {
            display: flex;
            // align-items: top;
            justify-content: center;
            .type_item {
                .type_icons {
                    display: flex;
                    align-items: top;
                    .lefts {
                        width: 148px;
                        height: 44px;
                        display: flex;
                        align-items: center;
                        .borders {
                            width: 148px;
                            height: 2px;
                            // background: #377CFD;
                            background: #F5F5F5;
                            border-radius: 0px 0px 0px 0px;
                        }
                    }
                    .consts {
                        .icons {
                            width: 44px;
                            height: 44px;
                            background: rgba(55, 124, 253, 0.06);
                            border-radius: 50%;
                            text-align: center;
                            line-height: 44px;
                            font-weight: 400;
                            font-size: 20px;
                            color: #999999;
                        }
                    }
                    .rigths {
                        width: 148px;
                        height: 44px;
                        display: flex;
                        align-items: center;
                        .borders {
                            width: 148px;
                            height: 2px;
                            // background: #377CFD;
                            background: #F5F5F5;
                            border-radius: 0px 0px 0px 0px;
                        }
                    }
                }

                .type_title {
                    text-align: center;
                    padding-top: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                }
                .type_time {
                    text-align: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #808080;
                    padding-top: 8px;
                }
            }
            .tyle_ac {
                .type_icons {
                    .lefts {
                        .borders {
                            background: #377CFD;
                        }
                    }
                    .consts {
                        .icons {
                            background: #377CFD;
                            color: #FFFFFF;
                        }
                    }
                    .rigths {
                        .borders {
                            background: #377CFD;
                        }
                    }
                }
                .type_title {}

                .type_time {}
            }
        }
        .order_state{
            padding-top: 82px;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            .lefts{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #55575B;
                span{
                    color: #007BFF;
                    cursor: pointer;
                    margin-left: 10px;
                }
            }
            .rights{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                span{
                    font-size: 20px;
                    color: #409EFF;
                }
            }
        }
    }
    .order_detial_box2{
        margin-top: 24px;
        background: #FFFFFF;
        padding: 32px;
        .title_flex{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 13px;
            border-bottom:1px solid #CCCCCC ;
            .lefts{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                display: flex;
                align-items: center;
                img{
                    width: 30px;
                    margin-right: 9px;
                }
            }
            .rights{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                cursor: pointer;
                display: flex;
                align-items: center;
                img{
                    width: 10px;
                    height: 10px;
                    margin-left: 8px;
                }
            }
        }
        .box_titles{
            padding-top: 32px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            padding-bottom: 16px;
        }
        .info_box1{
          
            .info_flex{
                display: flex;
                align-items: center;
                margin-bottom: 16px;
                .info_text1{
                    width: 90px;
                    text-align: right;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;

                }
                .info_text2{
                    margin-left: 10px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                   

                }
            }
            
          
           
        }
        .info_box2{
            padding-bottom: 60px;
            .dsr_info{
                padding-top: 32px;   
                .dsr_titles{
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                    padding-bottom: 11px
                }
                .dsr_border{
                    display: flex;
                    align-items: center;
                    padding-bottom: 25px;
                    .border1{
                        width: 36px;
                        height: 2px;
                        background: #377CFD;
                        border-radius: 0px 0px 0px 0px;
                        flex-shrink: 0;
                    }
                    .border2{
                        flex: 1;
                        height: 2px;
                        background-color: #E0E3E3;
                    }
                }
                .dsr_box{
                    width: 1131px;
                    height: 115px;
                    background: rgba(55,124,253,0.04);
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #E0E3E3;
                    display: flex;
                    margin-bottom: 24px;
                    padding: 16px;
                    .dsr_index{
                        width: 32px;
                        height: 32px;
                        background: #377CFD;
                        text-align: center;
                        line-height: 32px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        border-radius: 50%;
                    }
                    .dsr_items{
                        padding-left: 24px; 
                        .dsr_name{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                            // margin-top: 6px;
                            line-height: 32px;
                            cursor: pointer;
                        }   
                        .dsr_tages{
                            display: flex;
                            align-items: center;
                            margin-top: 30px;
                            .tages{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                margin-right: 50px;
                            }
                        }
                    }

                }

            }
        }
        .info_box3{
            padding-bottom: 60px;
            .info_flex{
                display: flex;
                // align-items: center;
                margin-bottom: 16px;
                .info_text1{
                    width: 90px;
                    text-align: right;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    flex-shrink: 0;

                }
                .info_text2{
                    margin-left: 10px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    .urls{
                        cursor: pointer;
                        &:hover{
                            color:#007BFF;
                        }
                    }

                }
            }
        }
        .info_box4{
            .list_0{
                padding-top: 48px;
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

                img{
                    width: 250px;
                }
            }
            .wt_list{
                padding-top: 33px;
                padding-bottom: 40px;
                .wt_item{
                    width: 1132px; 
                    height: 240px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #D7D7D7;
                    padding: 32px 30px;
                    .item_tops{
                        display: flex;
                        // align-items: center;
                        padding-bottom: 36px;
                        border-bottom: 1px solid #E8E8E8;
                        .top_lefts{
                            display: flex;
                            .cjls_img{
                                width: 90px;
                                flex-shrink: 0;
                                img{
                                    width: 90px;
                                    height: 90px;
                                }
                            }
                            
                        }
                        .top_rights{
                            padding-left: 30px;
                            flex: 1;
                            display: flex;
                            // align-items: center;
                            justify-content: space-between;
                            .cjls_info{
                                .cjls_name{
                                    display: flex;
                                    align-items: center;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 18px;
                                    color: #333333;
                                    img{
                                        width: 20px;
                                        height: 20px;
                                        margin-left: 8px;
                                    }
                                }
                                .cjls_tage{
                                    padding-top: 11px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #333333;
                                }
                                .cjls_consts{
                                    padding-top: 18px;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }
                            .cjls_btns{
                                .btns{
                                    width: 92px;
                                    height: 32px;
                                    background: #FFFFFF;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    text-align: center;
                                    line-height: 32px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #377CFD;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                    .item_boms{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding-top: 18px;
                        .num_flex{
                            display: flex;
                            align-items: center;
                            .num_item{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color:#666666;
                                margin-right: 80px;
                                span{
                                    color: #377CFD;
                                }
                            }
                         
                          
                        }
                        .num_btns{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }
            }

        }
        .info_box5{
            padding: 33px 20px;
            
            .fwjl_flex{
                display: flex;
                .fwjl_left{
                    width: 90px;
                    height: 90px;
                    flex-shrink: 0;
                    img{
                        width: 90px;
                        height: 90px;
                    }
                }
                .fwjl_right{
                    padding-left: 24px;
                    .fwjl_name{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                    }
                    .fwjl_jianjie{
                        padding-top: 21px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;

                    }
                }
                .fwjl_nums{
                    display: flex;
                    align-items: center;
                    padding-top: 10px;
                    .num_box{
                        display: flex;
                        align-items: center;
                       margin-right: 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        
                        span{
                            color: #377CFD;
                        }
                        img{
                            height: 15px;
                            margin-right: 10px;
                        }

                    }
                }
            }
        }
         .order_info {
            width: 1132px;
            min-height: 218px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;
            margin-top: 56px;

            .info_top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;

                .texts {
                    // width: 1132px;

                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                }

            }

            .info_bom {
                padding: 24px;

                .text_flex2 {
                    margin-top: 24px;
                }

                .text_flex {
                    display: flex;
                    align-items: baseline;
                    margin-bottom: 8px;

                    .text1 {
                        width: 500px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;

                    }

                    .text2 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }

                    .text3 {
                        width: 500px;
                        display: flex;
                        align-items: center;

                        .text3_1 {
                            // width: 70px;
                            text-align: left;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }

                        .text3_2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-left: 10px;
                        }
                    }

                    .text4 {
                        display: flex;
                        align-items: center;

                        .text4_1 {
                            width: 70px;
                            text-align: left;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }

                        .text4_2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-left: 10px;

                        }
                    }
                }
            }

        }
    }
    
}
</style>